const icons = {
  tBook: require("./assets/images/icons/book-flow-icons/talking-book.png"),
  fBook: require("./assets/images/icons/book-flow-icons/flip-book.png"),
  pBook: require("./assets/images/icons/book-flow-icons/photo-book.png"),
  cover: require("./assets/images/icons/book-flow-icons/cover.png"),


  create: require("./assets/images/icons/common-icons/create.png"),
  manage: require("./assets/images/icons/common-icons/manage.png"),
 
 
  mTBook: require("./assets/images/icons/sidebar-icons/talking-book.png"),
  mFBook: require("./assets/images/icons/sidebar-icons/flip-book.png"),
  mPBook: require("./assets/images/icons/sidebar-icons/photo-book.png"),

  dTBook: require("./assets/images/icons/dashboard-icons/talking-book.png"),
  dFBook: require("./assets/images/icons/dashboard-icons/flip-book.png"),
  dPBook: require("./assets/images/icons/dashboard-icons/photo-book.png"),
  dCover: require("./assets/images/icons/dashboard-icons/book-cover.png"),
};

export default icons;

